import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x.svg'
import _imports_1 from '@/app/ui/assets/svg/check-circle.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-0b266978")

_pushScopeId("data-v-0b266978")
const _hoisted_1 = { class: "font-montserrat" }
const _hoisted_2 = { class: "justify-center items-center flex overflow-hidden fixed inset-0 z-40 outline-none focus:outline-none" }
const _hoisted_3 = { class: "relative flex flex-col bg-white half-screen rounded-lg" }
const _hoisted_4 = { class: "border-b py-4 border-gray-lp-400" }
const _hoisted_5 = { class: "flex flex-row gap-4 px-8 w-full items-center" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "w-full font-semibold text-20px mr-4" }
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = { class: "px-8 pt-4 overflow-auto pb-10" }
const _hoisted_10 = { class: "flex flex-row gap-6 justify-between mt-4" }
const _hoisted_11 = { class: "flex flex-col gap-1 w-full" }
const _hoisted_12 = { class: "flex gap-x-2 pl-1 py-2 text-14px text-green-lp-400" }
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle-red"
}, null, -1)
const _hoisted_14 = { class: "flex flex-row gap-6 justify-between mt-4" }
const _hoisted_15 = {
  key: 0,
  class: "flex flex-row gap-6 justify-between mt-4"
}
const _hoisted_16 = {
  key: 1,
  class: "flex flex-row gap-6 justify-between mt-4"
}
const _hoisted_17 = { class: "w-1/2 flex flex-col" }
const _hoisted_18 = { class: "flex flex-row" }
const _hoisted_19 = { class: "flex flex-row" }
const _hoisted_20 = { class: "mx-2" }
const _hoisted_21 = { class: "flex flex-row gap-6 justify-end mt-4" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "opacity-50 fixed inset-0 z-30 bg-black" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_SelectPhoneCountryV2 = _resolveComponent("SelectPhoneCountryV2")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_LpButton = _resolveComponent("LpButton")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_Icons, { name: "icon-detail-sender" })
            ]),
            _createVNode("div", _hoisted_7, _toDisplayString(_ctx.type === "sender"
                  ? "Ubah detail pengirim"
                  : "Ubah detail penerima"), 1),
            _createVNode("div", _hoisted_8, [
              _createVNode("img", {
                src: _imports_0,
                class: "w-4 cursor-pointer",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onCloseWithReset && _ctx.onCloseWithReset(...args))),
                alt: "x"
              })
            ])
          ])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, [
              _createVNode(_component_DataWrapper, {
                label: 
                  _ctx.type === 'sender'
                    ? 'No. telepon pengirim'
                    : 'No. telepon penerima'
                ,
                class: "w-full"
              }, {
                default: _withId(() => [
                  _createVNode(_component_SelectPhoneCountryV2, {
                    error: _ctx.phoneNumberError,
                    phone: _ctx.phoneNumberValue,
                    code: _ctx.form.customerPhoneCode,
                    disabledUserDropdown: true,
                    keyName: "customerPhoneNumber",
                    onSetPhone: _ctx.setPhoneNumber,
                    onSetPhoneCode: _ctx.setPhoneCode
                  }, null, 8, ["error", "phone", "code", "onSetPhone", "onSetPhoneCode"])
                ]),
                _: 1
              }, 8, ["label"]),
              _withDirectives(_createVNode("div", _hoisted_12, [
                _hoisted_13,
                _createTextVNode(" " + _toDisplayString(_ctx.phoneNumberError.message), 1)
              ], 512), [
                [_vShow, _ctx.phoneNumberError.success && _ctx.phoneNumberError.message]
              ])
            ]),
            _createVNode(_component_DataWrapper, {
              label: 
                _ctx.type === 'sender'
                  ? _ctx.$t('bookingShipment.column.shipperName')
                  : _ctx.$t('bookingShipment.column.recipientName')
              ,
              class: "w-full"
            }, {
              default: _withId(() => [
                _createVNode(_component_LpInput, {
                  placeholder: 
                  _ctx.type === 'sender'
                    ? _ctx.$t('bookingShipment.placeholder.shipperName')
                    : _ctx.$t('bookingShipment.placeholder.recipientName')
                ,
                  modelValue: _ctx.form.customerName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.customerName = $event)),
                  error: _ctx.error.customerName,
                  "error-caption": _ctx.errorCaption.customerName,
                  maxlength: "100",
                  format: _ctx.formatName,
                  onChange: _ctx.validateName
                }, null, 8, ["placeholder", "modelValue", "error", "error-caption", "format", "onChange"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode(_component_DataWrapper, {
              label: 
                _ctx.type === 'sender'
                  ? _ctx.$t('bookingShipment.column.shipperAddress')
                  : _ctx.$t('bookingShipment.column.recipientAddress')
              ,
              class: "w-full"
            }, {
              default: _withId(() => [
                _createVNode(_component_lp_input, {
                  type: "textarea",
                  modelValue: _ctx.form.customerAddress,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.customerAddress = $event)),
                  error: _ctx.error.customerAddress,
                  "error-caption": _ctx.errorCaption.customerAddress,
                  preventEnterTextArea: true,
                  format: _ctx.replaceNewLine,
                  placeholder: 
                  _ctx.type === 'sender'
                    ? _ctx.$t('bookingShipment.placeholder.shipperAddress')
                    : _ctx.$t('bookingShipment.placeholder.recipientAddress')
                ,
                  maxLength: "255",
                  showMaxLength: true,
                  onChange: _ctx.validateAddress
                }, null, 8, ["modelValue", "error", "error-caption", "format", "placeholder", "onChange"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          (_ctx.type === 'receiver')
            ? (_openBlock(), _createBlock("div", _hoisted_15, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('bookingShipment.column.districtDestinationCity'),
                  optional: "",
                  class: "w-full"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_SelectSearch, {
                      class: "mt-1.5",
                      onFilter: _ctx.fetchdestinationCity,
                      isLoading: _ctx.isLoadingdestinationCity,
                      options: _ctx.destinationCityList,
                      keyName: "name",
                      keyValue: "id",
                      placeholder: 
                  _ctx.$t('bookingShipment.placeholder.districtDestinationCity')
                ,
                      modelValue: _ctx.destinationCity,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.destinationCity = $event)),
                      onFocus: _ctx.onFocusdestinationCity,
                      onChange: _ctx.onChangeDestinationCity
                    }, null, 8, ["onFilter", "isLoading", "options", "placeholder", "modelValue", "onFocus", "onChange"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('bookingShipment.column.postalCode'),
                  optional: "",
                  class: "w-full"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_SelectSearch, {
                      serverSide: false,
                      onFocus: _ctx.onFocusZipCode,
                      onFilter: _ctx.fetchZipCode,
                      onChange: _ctx.onChangeZipCode,
                      placeholder: _ctx.$t('bookingShipment.placeholder.postalCode'),
                      class: "mt-2",
                      keyName: "name",
                      keyValue: "code",
                      options: _ctx.zipCodeList,
                      modelValue: _ctx.zipCode,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.zipCode = $event))
                    }, null, 8, ["onFocus", "onFilter", "onChange", "placeholder", "options", "modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.type === 'receiver')
            ? (_openBlock(), _createBlock("div", _hoisted_16, [
                _createVNode("div", _hoisted_17, [
                  _createVNode("div", _hoisted_18, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listAddressType, (item, index) => {
                      return (_openBlock(), _createBlock("label", {
                        key: index,
                        class: 'radioCustom'
                      }, [
                        _createVNode("input", {
                          type: "radio",
                          value: _ctx.form.customerAddressType,
                          checked: _ctx.form.customerAddressType === item.value,
                          id: item,
                          onChange: ($event: any) => (_ctx.onSelectAddressType(item.name, item.value)),
                          name: "radio-input",
                          class: "w-full whitespace-no-wrap my-2 z-10"
                        }, null, 40, ["value", "checked", "id", "onChange"]),
                        _createVNode("div", _hoisted_19, [
                          _createVNode(_component_Icons, {
                            name: item.name === 'Rumah' ? 'home-type' : 'office',
                            class: "cursor-pointer ml-2 h-6"
                          }, null, 8, ["name"]),
                          _createVNode("span", _hoisted_20, _toDisplayString(item.name), 1)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_21, [
            _createVNode(_component_LpButton, {
              title: "Simpan",
              onClick: _ctx.requestEditCustomer,
              textColor: "white",
              disabled: _ctx.isSaveDisabled
            }, null, 8, ["onClick", "disabled"])
          ])
        ])
      ])
    ]),
    _hoisted_22
  ]))
})